module.exports = __webpack_public_path__ + "media/bootstrap-icons/envelope-2cede5c3.svg";